
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import HomeBG from '../../resources/homeBgIm.png';

import SpeciaLogo2 from '../../resources/circle specia 2.png';

import SpeciaLogo from '../../resources/speciaLogo.png';

import SecurityImg from '../../resources/Security.png';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.png';

import BGD from '../../resources/BGD1.png';

import TeamLogo from '../../resources/chart.png';

import PlayButton from '../../resources/playbutton.png';

import Cookies from 'universal-cookie';

import { Button } from 'react-bootstrap';
import { ButtonBase } from '@mui/material';

export default function Solutions() {


    const navigate = useNavigate();

  const auth = useAuth();

  const [
    searchParams,
    setSearchParams,
  ] = useSearchParams();
  const token = searchParams.get('token');

  const [
    status,
    setStatus,
  ] = useState(200);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const cookies = new Cookies();

    const currentPath = cookies.get('currentPath') || '/'






return (
    <>
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                textAlign: 'center',
                alignItems: 'center',
                padding: '0 8vw'
            }}
        >
            {/* Title */}
            <div
                style={{
                    borderBottom: 'solid 0.08vw rgb(0, 0, 0, 0.5)',
                    width: '100%',
                    marginTop: '5vw',
                    fontSize: '2.5vw',
                    textAlign: 'left',
                    paddingBottom: '1vw'
                }}
            >
                Solutions
            </div>

            {/* Cards */}
            <div
                style={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '1vw',
                    padding: '5vw 0 3vw 0'
                }}
            >
                <SolutionCard
                    title="Scout"
                    subtitle="ATO Report Retrieval"
                    points={[
                        'Instantly fetches BAS, IAS, ICA, and ITA reports from the ATO portal in one click',
                        'Eliminates the need to manually log in and download each report individually',
                        'Saves time and ensures complete, consistent data retrieval for compliance'
                    ]}
                />

                <SolutionCard
                    title="Gary"
                    subtitle="Workpaper Generation"
                    points={[
                        'Automatically compiles workpapers by pulling data from ATO, XERO, and MYOB',
                        'Applies user-defined templates to maintain flexibility and firm-specific formats',
                        'Streamlines preparation and reduces human error in manual data entry'
                    ]}
                />

                <SolutionCard
                    title="Omni"
                    subtitle="Client Communication"
                    points={[
                        'Automates client-facing ATO communication based on customizable rules',
                        'Forwards ATO documents to clients with attachments and branded email templates',
                        'Enhances transparency and reduces the manual effort of staying compliant'
                    ]}
                />

                <SolutionCard
                    title="Eva"
                    subtitle="Individual Client Communication"
                    points={[
                        'Automates client-facing ATO communication for individuals based on customizable rules',
                        'Forwards ATO documents to individual clients with attachments and branded email templates',
                        'Enhances transparency and reduces the manual effort of staying compliant'
                    ]}
                />
            </div>

            {/*  COMMON STATIC BUTTON */}
            <div
                style={{
                    marginBottom: '-2vw',
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <ButtonBase
                    onClick={() => auth.signinRedirect()}
                    style={{
                        padding: '1vw 2.5vw',
                        borderRadius: '0.6vw',
                        backgroundColor: '#39887F',
                        color: 'white',
                        fontSize: '1vw',
                        fontWeight: 500,
                        letterSpacing: '0.05vw',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={e =>
                        (e.currentTarget.style.backgroundColor = '#2f6f68')
                    }
                    onMouseLeave={e =>
                        (e.currentTarget.style.backgroundColor = '#39887F')
                    }
                >
                    Explore Solutions
                </ButtonBase>
            </div>
        </div>
    </>
);
}


function SolutionCard({ title, subtitle, points, onClick }) {

    const [hovered, setHovered] = useState(false);

    return (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
                position: 'relative',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                padding: '1vw',
                borderRadius: '1vw',
                cursor: 'pointer',
                overflow: 'hidden',

                /* COMPACT → EXPAND */
                minHeight: hovered ? 'auto' : '18vw',

                transition: 'min-height 0.45s ease, transform 0.25s ease, box-shadow 0.25s ease',
                transform: hovered ? 'translateY(-0.6vw)' : 'translateY(0)',
                boxShadow: hovered
                    ? '0 1.2vw 3vw rgba(0, 0, 0, 0.18)'
                    : '0 0.4vw 1.2vw rgba(0, 0, 0, 0.08)'
            }}
        >
            {/*  Blur overlay */}
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: hovered
                        ? 'rgba(255, 255, 255, 0.55)'
                        : 'transparent',
                    backdropFilter: hovered ? 'blur(8px)' : 'blur(0)',
                    transition: 'all 0.35s ease',
                    zIndex: 1
                }}
            />

            {/*  Title  */}
            <p
                style={{
                    position: 'absolute',
                    top: '45%',
                    left: '50%',
                    transform: hovered
                        ? 'translate(-50%, -12.5vw)'
                        : 'translate(-50%, -50%)',
                    fontSize: '3vw',
                    fontWeight: 500,
                    textAlign: 'center',
                    transition: 'all 0.45s ease',
                    zIndex: 2,
                    pointerEvents: 'none'
                }}
            >
                {title}
            </p>

            {/*  Subtitle  */}
            <p
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: hovered
                        ? 'translate(-50%, -10.1vw)'
                        : 'translate(-50%, calc(-50% + 3.5vw))',
                    fontSize: '1.2vw',
                    fontWeight: 500,
                    textAlign: 'center',
                    transition: 'all 0.45s ease',
                    zIndex: 2,
                    pointerEvents: 'none'
                }}
            >
                {subtitle}
            </p>

            {/*  Content */}
            <div
                style={{
                    position: 'relative',
                    zIndex: 2,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '8vw',

                    /*  Reveal AFTER expansion */
                    opacity: hovered ? 1 : 0,
                    transition: 'opacity 0.35s ease',
                    transitionDelay: hovered ? '0.25s' : '0s'
                }}
            >
                {/* Details */}
                <div
                    style={{
                        width: '100%',
                        maxHeight: hovered ? '18vw' : '0',
                        overflowY: hovered ? 'auto' : 'hidden',
                        transition: 'all 0.35s ease',
                        paddingRight: hovered ? '0.5vw' : '0'
                    }}
                >
                    <ul style={{listStyleType: 'none', paddingLeft: '1vw', marginBottom: '2vw' }}>
                        {points.map((p, i) => (
                            <li
                                key={i}
                                style={{
                                    fontSize: '0.9vw',
                                    lineHeight: '1.6vw',
                                    fontWeight: 300,
                                    marginBottom: '1vw'
                                }}
                            >
                                {p}
                            </li>
                        ))}
                    </ul>
                </div>

            </div>
        </div>
    );
}



